import { render } from "./FormSelectMolecule.vue?vue&type=template&id=a632bba4&ts=true"
import script from "./FormSelectMolecule.vue?vue&type=script&lang=ts"
export * from "./FormSelectMolecule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__